import { SolViewId, SolViewOptions } from '@sol/components';

export class AsmAssetsViewId {
  public static readonly hostTechnologyLabelEdit = SolViewId.of<SolViewOptions>('hostTechnologyLabelEdit');
  public static readonly domainTechnologyLabelEdit = SolViewId.of<SolViewOptions>('domainTechnologyLabelEdit');
  public static readonly websiteTechnologyLabelEdit = SolViewId.of<SolViewOptions>('websiteTechnologyLabelEdit');
}
